import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { RequestOptions } from '../core';
import { HttpService } from '../core/services/http.service';
import { QCApprovalResponseDto,ChecksheetStepRowDto, DOWN_TIME_CODE_ODATA_URL, IAssignSerialNumberFormData, ICreateRejectPLN, ICreateReworkPLN, IDownTimeCode, IDownTimeData, IMachineUtilityDashboard, IMaintenance, IMaintenanceType, IPartCategorySerialConfiguration, IPartSerialConfiguration, IProcessOutputLocation, IProcessRoutingStepAttachment, IProductionLineNumber, IProductionOrder, IProductionOrderLine, IProductionOrderStatus, ISerialNumberConfiguration, ISerialNumberDetail, JOB_ODATA_URL, MAINTENANCE_TYPE_ODATA_URL, PROCESS_INPUT_ODATA_URL, PROCESS_ROUTING_ODATA_URL, PRODUCTION_ORDER_STATUS_ODATA_URL, QCStepValueDto, SHIFT_EMPLOYEE_ODATA_URL, SHIFT_ODATA_URL, ProcessRoutingStepInputProperty, IMaintenanceRecurrence } from './production-model';
import { IOperation, IProcess, IProcessInputDetail, IProcessOutputDetail,IProcessRouting,IProcessRoutingStep,IProcessRoutingStepTool,IProcessRoutingTool,IShift,IShiftEmployee,OPERATION_ODATA_URL,PROCESS_ODATA_URL } from './production-model';
import { Attachment } from '../shared/components/attach-document/add-edit-attachment/add-edit-attachment.component';
import { HttpParams } from '@angular/common/http';
import { ToISODate } from '../Utils/date-time.helper';

@Injectable()
export class ProductionService {
  private readonly workstationUrl = `${environment.baseApiUrl}/WorkStation`;
  private readonly workstationEventUrl = `${environment.baseApiUrl}/WorkStationEvent`;
  private readonly partUrl = `${environment.baseApiUrl}/Part`;
  private readonly processUrl = `${environment.baseApiUrl}/Process`;
  private readonly processInputUrl = `${environment.baseApiUrl}/ProcessInput`;
  private readonly processOutputUrl = `${environment.baseApiUrl}/ProcessOutput`;
  private readonly processRoutingUrl = `${environment.baseApiUrl}/ProcessRouting`;
  private readonly salesOrderUrl = `${environment.baseApiUrl}/Order`;
  private readonly productionUrl = `${environment.baseApiUrl}/Production`;
  private readonly processRoutingToolUrl = `${environment.baseApiUrl}/ProcessRoutingTool`;
  private readonly processRoutingStepUrl = `${environment.baseApiUrl}/ProcessRoutingStep`;
  private readonly processRoutingStepInputUrl = `${environment.baseApiUrl}/ProcessRoutingStepInput`;
   private readonly processRoutingStepOutputUrl = `${environment.baseApiUrl}/ProcessRoutingStepOutput`;
  private readonly ProcessRoutingStepAttribute = `${environment.baseApiUrl}/ProcessRoutingStepAttribute`;
  private readonly processRoutingStepAttachmentUrl = `${environment.baseApiUrl}/ProcessRoutingStepAttachment`;
  private readonly processRoutingStepToolUrl = `${environment.baseApiUrl}/ProcessRoutingStepTool`;
  private readonly shiftUrl = `${environment.baseApiUrl}/Shift`;
  private readonly shiftEmployeeUrl = `${environment.baseApiUrl}/ShiftEmployee`;
  private readonly operationUrl = `${environment.baseApiUrl}/Operation`;
  private readonly jobUrl = `${environment.baseApiUrl}/Job`;
  private readonly processOutputLocationUrl = `${environment.baseApiUrl}/ProcessOutputLocation`; 
  private readonly dailyAverageUrl = `${environment.baseApiUrl}/Dashboard/Daily/Average`;
  private readonly dailyDataUrl = `${environment.baseApiUrl}/Dashboard/Daily`;
  private readonly dailyAccelerometerDataUrl = `${environment.baseApiUrl}/Dashboard/Daily/Accelerometer`;
  private readonly scloudDataUrl = `${environment.baseApiUrl}/Dashboard/Daily/SCloud`;
  private readonly machineStatusesUrl = `${environment.baseApiUrl}/Dashboard/MachinesByStatus`;
  private readonly jobStatusesUrl = `${environment.baseApiUrl}/Dashboard/JobsByStatus`;
  private readonly deviceJobsUrl = `${environment.baseApiUrl}/Dashboard/workStation`;
  private readonly workStationsUrl = `${environment.baseApiUrl}/Dashboard/WorkStations`;
  private readonly deviceDataUrl = `${environment.baseApiUrl}/Dashboard/Device/Info`;
  private readonly maintenanceUrl = `${environment.baseApiUrl}/Maintenance`;
  private readonly maintenanceAttachmentUrl = `${environment.baseApiUrl}/MaintenanceAttachment`;
  private readonly maintenanceTypeUrl = `${environment.baseApiUrl}/MaintenanceType`;
  private readonly AllWorkStationsUrl = `${environment.baseApiUrl}/Dashboard/AllWorkStations`;
  private readonly GetWorkStationsForDashboardUrl = `${environment.baseApiUrl}/Dashboard/WorkStationsForDashboard`;
  private readonly productionCountByWorkStatinUrl = `${environment.baseApiUrl}/Dashboard/ProductionByWorkStation`;
  private readonly workStationStutusDataUrl = `${environment.baseApiUrl}/Dashboard/WorkStationStatusCard`;
  private readonly cycleTimeByWorkStationUrl = `${environment.baseApiUrl}/Dashboard/CycleTime`;
  private readonly oeeAnalysisUrl = `${environment.baseApiUrl}/Dashboard/OEEAnalysis`;
  private readonly historyDataByWorkStationUrl = `${environment.baseApiUrl}/Dashboard/HistoryData`;
  private readonly availabilityByWorkStationUrl = `${environment.baseApiUrl}/Dashboard/Availability`;
  private readonly performanceByWorkStationUrl = `${environment.baseApiUrl}/Dashboard/Performance`;
  private readonly qualityByWorkStationUrl = `${environment.baseApiUrl}/Dashboard/Quality`;
  private readonly oeeByWorkStationUrl = `${environment.baseApiUrl}/Dashboard/OEE`;
  private readonly productionByDateUrl = `${environment.baseApiUrl}/Dashboard/ProductionByDate`;
  private readonly downTimeAnalysisByWorkStationUrl = `${environment.baseApiUrl}/Dashboard/DownTimeAnalysis`;
  private readonly productionOrderUrl = `${environment.baseApiUrl}/ProductionOrder`;
  private readonly productionOrderStatusUrl = `${environment.baseApiUrl}/ProductionOrderStatus`;
  private readonly downTimeCodeUrl = `${environment.baseApiUrl}/DownTimeCode`;
  private readonly productionOrderLineUrl = `${environment.baseApiUrl}/ProductionOrderLine`;
  private readonly productionLineNumberUrl = `${environment.baseApiUrl}/ProductionLineNumber`;
  private readonly serialNumberUrl = `${environment.baseApiUrl}/SerialNumber`;
  private readonly serialNumberConfigurationOdataUrl = `${environment.baseOdataUrl}/SerialNumberConfigurations`;
  private readonly serialNumberConfigurationUrl = `${environment.baseApiUrl}/SerialNumberConfiguration`;
  private readonly partCategprySerialNumberConfigurationUrl = `${environment.baseApiUrl}/PartCategorySerialNumberConfiguration`;
  private readonly partSerialNumberConfigurationUrl = `${environment.baseApiUrl}/PartSerialNumberConfiguration`;
  private readonly serialNumberDetailUrl = `${environment.baseApiUrl}/SerialNumberDetail`;
  private readonly batchNumberUrl = `${environment.baseApiUrl}/BatchNumber`;
  private readonly downTimeDataUrl = `${environment.baseApiUrl}/DownTimeData`;
  private readonly partBomUrl = `${environment.baseApiUrl}/PartBOM`;
  private readonly machineUtilityDashboard = `${environment.baseApiUrl}/Dashboard/machine-utilization`
  private readonly machineUtilityDashboardGrid = `${environment.baseApiUrl}/Dashboard/machine-utilization/list`
  private readonly scheduleJobUrl = `${environment.baseApiUrl}/ScheduleJob`
  private readonly jobExecutionQualityUrl = `${environment.baseApiUrl}/JobExecutionQuality`
  private readonly reworkJobUrl = `${environment.baseApiUrl}/ReworkJob`;
  private readonly rejectJobUrl = `${environment.baseApiUrl}/RejectJob`;
  constructor(private httpService: HttpService) {}

  getAllProductionsByDate(startRange : any, endRange: any){
    let params = new HttpParams().append('startDate', ToISODate(startRange).toISOString()).append('endDate', ToISODate(endRange).toISOString());
    return this.httpService.get(this.productionByDateUrl, params).toPromise();
  }

  getWorkstationById(workstationId: number){
    return this.httpService.getData(`${this.workstationUrl}/${workstationId}`);
   }

  getWorkstationDetailsById(workStationId: number) {
    return this.httpService.getData(`${this.workstationUrl}/${workStationId}/details`);
  }

  updateWorkstation(workstationId: number, workstation: any){
    let url = `${this.workstationUrl}/${workstationId}`;
    workstation.Id = workstationId;
    return this.httpService.put(url, workstation);
  }

  addWorkstationEvent(workstationEvent: any){
    let url = `${this.workstationEventUrl}`;
    return this.httpService.post(url, workstationEvent);
  }

  //#region Process
  getProcess(requestOptions: RequestOptions) {
    return this.httpService.getPaginatedData(this.processUrl, requestOptions);
  }

  getProcessById(processId: number) {
    return this.httpService.getData(`${this.processUrl}/${processId}`);
  }

  addProcess(process: IProcess) {
    return this.httpService.post(this.processUrl, process);
  }

  updateProcess(processId: number, process: IProcess) {
    let url = `${this.processUrl}/${processId}`;
    process.Id = processId;
    return this.httpService.put(url, process);
  }

  deleteProcess(processId: number) {
    let url = `${this.processUrl}/${processId}`;
    return this.httpService.delete(url);
  }


  checkifCombinationExist(workStationId: any,id:number,operationId:any) : Promise<Boolean>{
    let filter = `WorkStationId eq ${workStationId} and OperationId eq ${operationId}`;
    if(id){
    filter += `and Id ne ${id}`;
    }
    return this.httpService
       .getODataCount(PROCESS_ODATA_URL, { filter: filter })
       .then(count => !(count > 0));
  }
  //#endregion

  //#region Process Routing

  getProcessRoutingByPartId(partId: number){
    return this.httpService.getOData(PROCESS_ROUTING_ODATA_URL, { filter: `PartId eq ${partId}` });
  }

  getProcessRouting(requestOptions: RequestOptions) {
    return this.httpService.getPaginatedData(
      this.processRoutingUrl,
      requestOptions
    );
  }

  getProcessRoutingDetailsById(processRoutingId: number) {
    return this.httpService.getData(
      `${this.processRoutingUrl}/${processRoutingId}`
    );
  }

  addProcessRouting(processRouting: IProcessRouting) {
    return this.httpService.post(this.processRoutingUrl, processRouting);
  }

  getProcessRoutingById(processRoutingId: number) {
    return this.httpService.getData(`${this.processRoutingUrl}/${processRoutingId}`);
  }

  updateProcessRouting(processRoutingId: number, processRouting: IProcessRouting) {
    let url = `${this.processRoutingUrl}/${processRoutingId}`;
    processRouting.Id = processRoutingId;
    return this.httpService.put(url, processRouting);
  }

  deleteProcessRouting(processRoutingId: number) {
    let url = `${this.processRoutingUrl}/${processRoutingId}`;
    return this.httpService.delete(url);
  }

  importProcessRouting(data: any) {
    let url = `${environment.baseApiUrl}/Import/Process/Routing`;
    return this.httpService.post(url,data);
  }

  saveImportedProcessRouting(data : any){
    let url = `${environment.baseApiUrl}/Import/Process/Routing/Save`;
    return this.httpService.post(url, data);
  }

  getAllWorkStationsWithGroup(){
    return this.httpService.getData(`${this.workstationUrl}/AllWorkStationsWithGroup`);
  }

  checkProcessRoutingData(data : any){
    let url = `${environment.baseApiUrl}/Import/Process/Routing/Check`;
    return this.httpService.post(url, data);
  }
  //#endregion

  //#region Process Input

  getProcessInput(requestOptions: RequestOptions, id: number) {
    let processInputsUrl = `${this.processRoutingUrl}/${id}/ProcessInput`;
    return this.httpService.getPaginatedData(processInputsUrl, requestOptions);
  }

  getProcessInputDetailsById(processInputId: number | any) {
    return this.httpService.getData(
      `${this.processInputUrl}/${processInputId}`
    );
  }

  addProcessInput(processInputDetail: IProcessInputDetail, id: number) {
    let detailUrl = `${this.processRoutingUrl}/${id}/ProcessInput`;
    return this.httpService.post(detailUrl, processInputDetail);
  }

  deleteProcessInput(processInputId: number) {
    let url = `${this.processInputUrl}/${processInputId}`;
    return this.httpService.delete(url);
  }
  updateProcessInput(processInputId: number,processInputDetail: IProcessInputDetail) {
    let url = `${this.processInputUrl}/${processInputId}`;
    processInputDetail.ProcessInputId = processInputId;
    return this.httpService.put(url, processInputDetail);
  }

 getPartBOMByRoutingId(processRoutingId: number) {
  const url = `${this.processRoutingUrl}/processRouting/${processRoutingId}/PartBom`;
  return this.httpService.getData(url);
}


  getUnitOfMeasureIdByPartId(partId: number){
    let url = `${environment.baseOdataUrl}/Parts/${partId}`;
    return this.httpService.getOData(url, {select: "DefaultUnitOfMeasureId"});
  }

  checkifPartExists(partId: number|any,id:number) : Promise<Boolean>{
    let filter = `PartId eq ${partId}`;
    if(id){
      filter+=` and Id ne ${id}`;
    }
    return this.httpService
              .getODataCount(PROCESS_INPUT_ODATA_URL, { filter: filter })
              .then(count => !(count > 0));
  }
  //#endregion

  //#region Process Output
  getProcessOutput(requestOptions: RequestOptions, id: number) {
    let processOutputsUrl = `${this.processRoutingUrl}/${id}/ProcessOutput`;
    return this.httpService.getPaginatedData(processOutputsUrl, requestOptions);}

  addProcessOutput(processOutputDetail: IProcessOutputDetail, id: number) {
      let detailUrl = `${this.processRoutingUrl}/${id}/ProcessOutput`;
      return this.httpService.post(detailUrl, processOutputDetail);
  }
  getProcessOutputDetailsById(processOutputId: number | any) {
    return this.httpService.getData(
      `${this.processOutputUrl}/${processOutputId}`
    );
  }
  updateProcessOutput(processOutputId: number,processOutputDetail: IProcessOutputDetail) {
    let url = `${this.processOutputUrl}/${processOutputId}`;
    processOutputDetail.ProcessOutputId = processOutputId;
    return this.httpService.put(url, processOutputDetail);
  }
  deleteProcessOutput(processOutputId: number) {
    let url = `${this.processOutputUrl}/${processOutputId}`;
    return this.httpService.delete(url);
  }
  //#endregion

  //#region Control Panel Order

  getSalesOrderLines(requestOptions: RequestOptions, id:number|any){
    let salesOrderLinesDetailUrl = `${this.salesOrderUrl}/${id}/OrderLines`;
    return this.httpService.getPaginatedData(salesOrderLinesDetailUrl, requestOptions);
  }

  getOrderPartsWithProcessRouting(orderId:number|any){
    let url = `${this.productionUrl}/Order/${orderId}/Parts`;
    return this.httpService.getData(url);
  }

  getPartBOMDetails(partId: number){
    let url = `${this.partUrl}/${partId}/PartBOM`;
    return this.httpService.getData(url);
  }

  getPartsWithProcessRouting(PartCategoryId:number|any){
    let url = `${this.productionUrl}/PartCategory/${PartCategoryId}/Parts`;
    return this.httpService.getData(url);
  }
  //#region Process Routing Tool

  getProcessRoutingTool(requestOptions: RequestOptions, id: number) {
    let processRoutingToolUrl = `${this.processRoutingUrl}/${id}/ProcessRoutingTool`;
    return this.httpService.getPaginatedData(processRoutingToolUrl, requestOptions);
  }

  getProcessRoutingToolById(processRoutingToolId: number | any) {
    return this.httpService.getData(
      `${this.processRoutingToolUrl}/${processRoutingToolId}`
    );
  }

  addProcessRoutingTool(processRoutingTool: IProcessRoutingTool, id: number) {
    let detailUrl = `${this.processRoutingUrl}/${id}/ProcessRoutingTool`;
    return this.httpService.post(detailUrl, processRoutingTool);
  }

  deleteProcessRoutingTool(processRoutingToolId: number) {
    let url = `${this.processRoutingToolUrl}/${processRoutingToolId}`;
    return this.httpService.delete(url);
  }
  updateProcessRoutingTool(processRoutingToolId: number,processRoutingTool: IProcessRoutingTool) {
    let url = `${this.processRoutingToolUrl}/${processRoutingToolId}`;
    processRoutingTool.Id = processRoutingToolId;
    return this.httpService.put(url, processRoutingTool);
  }
  //#endregion

  //#region Process Routing Step

  getProcessRoutingStep(requestOptions: RequestOptions, id: number) {
    let processRoutingStepUrl = `${this.processRoutingUrl}/${id}/ProcessRoutingStep`;
    return this.httpService.getPaginatedData(processRoutingStepUrl, requestOptions);
  }

  getProcessRoutingStepById(processRoutingStepId: number | any) {
    return this.httpService.getData(
      `${this.processRoutingStepUrl}/${processRoutingStepId}`
    );
  }

  addProcessRoutingStep(processRoutingStep: IProcessRoutingStep, id: number) {
    let detailUrl = `${this.processRoutingUrl}/${id}/ProcessRoutingStep`;
    return this.httpService.post(detailUrl, processRoutingStep);
  }

  deleteProcessRoutingStep(processRoutingStepId: number) {
    let url = `${this.processRoutingStepUrl}/${processRoutingStepId}`;
    return this.httpService.delete(url);
  }
  updateProcessRoutingStep(processRoutingStepId: number,processRoutingStep: IProcessRoutingStep) {
    let url = `${this.processRoutingStepUrl}/${processRoutingStepId}`;
    processRoutingStep.Id = processRoutingStepId;
    return this.httpService.put(url, processRoutingStep);
  }

  getLastProcessRoutingStepForPriorityOrder(processRoutingId: number){
    let url = `${this.processRoutingStepUrl}/${processRoutingId}/PriorityOrder`;
    return this.httpService.getData(url);
  }

  // checkIfLeadPriorityOrderExists(
  //   priorityOrder: string,
  //   LeadTermId: number,
  //   id: number
  // ): Promise<Boolean> {
  //   let filter = `PriorityOrder eq ${priorityOrder} and LeadId eq ${id}`;

  //   if (LeadTermId) {
  //     filter += ` and Id ne ${LeadTermId}`;
  //   }
  //   return this.httpService
  //     .getODataCount(LEAD_TERMS_ODATA_URL, { filter: filter })
  //     .then((count) => !(count > 0));
  // }
  //#endregion

  //#region process routing step tool
  getProcessRoutingStepTool(requestOptions: RequestOptions, id: number){
    let processRoutingStepToolUrl = `${this.processRoutingStepUrl}/${id}/ProcessRoutingStepTool`;
    return this.httpService.getPaginatedData(processRoutingStepToolUrl, requestOptions);
  }

  addProcessRoutingStepTool(id: number| any, processRoutingStepTool: IProcessRoutingStepTool){
    let url = `${this.processRoutingStepUrl}/${id}/ProcessRoutingStepTool`;
    return this.httpService.post(url, processRoutingStepTool);
  }

  getProcessRoutingStepToolById(processRoutingStepToolId: number){
    return this.httpService.getData(`${this.processRoutingStepToolUrl}/${processRoutingStepToolId}`);
   }

   updateProcessRoutingStepTool(processRoutingStepToolId: number, processRoutingStepTool: IProcessRoutingStepTool){
    let url = `${this.processRoutingStepToolUrl}/${processRoutingStepToolId}`;
    processRoutingStepTool.Id = processRoutingStepToolId;
    return this.httpService.put(url, processRoutingStepTool);
  }
  
  deleteProcessRoutingStepTool(processRoutingStepToolId: number){
    let url = `${this.processRoutingStepToolUrl}/${processRoutingStepToolId}`;
    return this.httpService.delete(url);
  }
  //#endregion 

   //#region process routing step attachment
   getProcessRoutingStepAttachments(requestOptions: RequestOptions, id: number){
    let processRoutingStepAttachmentUrl = `${this.processRoutingStepUrl}/${id}/ProcessRoutingStepAttachment`;
    return this.httpService.getPaginatedData(processRoutingStepAttachmentUrl, requestOptions);
  }

  getProcessRoutingStepAttachmentById(processRoutingStepAttachmentId: number){
    return this.httpService.getData(`${this.processRoutingStepAttachmentUrl}/${processRoutingStepAttachmentId}`);
   }

   addProcessRoutingStepAttachment(processRoutingStepId: number, attachment: Attachment){
    let processRoutingStepAttachmentsDetailUrl = `${this.processRoutingStepUrl}/${processRoutingStepId}/ProcessRoutingStepAttachment`;
    return this.httpService.post(processRoutingStepAttachmentsDetailUrl, { ProcessRoutingStepId: processRoutingStepId, ...attachment });
  }
    
  updateProcessRoutingStepAttachment(processRoutingStepAttachmentId: number, processRoutingStepId: number, attachment: Attachment){
    let url = `${this.processRoutingStepAttachmentUrl}/${processRoutingStepAttachmentId}`;
    return this.httpService.put(url, { Id: processRoutingStepAttachmentId, processRoutingStepId: processRoutingStepId, ...attachment });
  }
    
  deleteProcessRoutingStepAttachment(processRoutingStepAttachmentId: number){
    let url = `${this.processRoutingStepAttachmentUrl}/${processRoutingStepAttachmentId}`;
    return this.httpService.delete(url)
  }
  //#endregion

  //#region shift
  getShifts(requestOptions: RequestOptions){
    return this.httpService.getPaginatedData(this.shiftUrl, requestOptions);
  }

  addShift(shift: IShift){
    return this.httpService.post(this.shiftUrl, shift);
  }

  getShiftById(shiftId: number){
    return this.httpService.getData(`${this.shiftUrl}/${shiftId}`);
   }

  updateShift(shiftId: number, shift: IShift){
    let url = `${this.shiftUrl}/${shiftId}`;
    shift.Id = shiftId;
    return this.httpService.put(url, shift);
  }

  deleteShift(shiftId: number){
    let url = `${this.shiftUrl}/${shiftId}`;
    return this.httpService.delete(url);
  }

  checkIfShiftCodeExists(shiftCode: string,id: number) : Promise<Boolean>{
    let filter = `ShiftCode eq '${shiftCode}'`;

    if(id){
      filter+=` and Id ne ${id}`;
    }
    return this.httpService
              .getODataCount(SHIFT_ODATA_URL, { filter: filter })
              .then(count => !(count > 0));
  }

  checkIfShiftExist(shiftId: any,id:number) : Promise<Boolean>{
    let filter = `Name eq '${shiftId}'`;
    if(id){
    filter += `and Id ne ${id}`;
    }
    return this.httpService
       .getODataCount(SHIFT_ODATA_URL, { filter: filter })
       .then(count => !(count > 0));
  }

  //#endregion

  //#region shift employee
  getShiftEmployees(requestOptions: RequestOptions){
    return this.httpService.getPaginatedData(this.shiftEmployeeUrl, requestOptions);
  }

  addShiftEmployee(shiftEmployee: IShiftEmployee){
    return this.httpService.post(this.shiftEmployeeUrl, shiftEmployee);
  }

  getShiftEmployeeById(shiftEmployeeId: number){
    return this.httpService.getData(`${this.shiftEmployeeUrl}/${shiftEmployeeId}`);
   }

  updateShiftEmployee(shiftEmployeeId: number, shiftEmployee: IShiftEmployee){
    let url = `${this.shiftEmployeeUrl}/${shiftEmployeeId}`;
    shiftEmployee.Id = shiftEmployeeId;
    return this.httpService.put(url, shiftEmployee);
  }

  deleteShiftEmployee(shiftEmployeeId: number){
    let url = `${this.shiftEmployeeUrl}/${shiftEmployeeId}`;
    return this.httpService.delete(url);
  }

  checkIfShiftEmployeeExist(employeeId: any,shiftId:any,id:number) : Promise<Boolean>{
    let filter = `EmployeeId eq ${employeeId} and ShiftId eq ${shiftId}`;
    if(id){
    filter += `and Id ne ${id}`;
    }
    return this.httpService
       .getODataCount(SHIFT_EMPLOYEE_ODATA_URL, { filter: filter })
       .then(count => !(count > 0));
  }
  //#endregion

  
  //#region operation
  getOperation(requestOptions: RequestOptions){
    return this.httpService.getPaginatedData(this.operationUrl, requestOptions);
  }

  addOperation(operation: IOperation){
    return this.httpService.post(this.operationUrl, operation);
  }

  getOperationById(operationId: number){
    return this.httpService.getData(`${this.operationUrl}/${operationId}`);
   }

  updateOperation(operationId: number, operation: IOperation){
    let url = `${this.operationUrl}/${operationId}`;
    operation.Id = operationId;
    return this.httpService.put(url, operation);
  }

  deleteOperation(operationId: number){
    let url = `${this.operationUrl}/${operationId}`;
    return this.httpService.delete(url);
  }

  checkifOperationExist(operationId: any,id:number) : Promise<Boolean>{
    let filter = `Name eq '${operationId}'`;
    if(id){
    filter += `and Id ne ${id}`;
    }
    return this.httpService
       .getODataCount(OPERATION_ODATA_URL, { filter: filter })
       .then(count => !(count > 0));
  }
  //#endregion

  //#region process output location
  getProcessOutputLocation(requestOptions: RequestOptions, id: number){
    let processOutputLocationUrl = `${this.processOutputUrl}/${id}/Location`;
    return this.httpService.getPaginatedData(processOutputLocationUrl, requestOptions);
  }

  addProcessOutputLocation(id: number| any, processOutputLocation: IProcessOutputLocation){
    let url = `${this.processOutputUrl}/${id}/Location`;
    return this.httpService.post(url, processOutputLocation);
  }

  getProcessOutputLocationById(processOutputLocationId: number){
    return this.httpService.getData(`${this.processOutputLocationUrl}/${processOutputLocationId}`);
   }

   updateProcessOutputLocation(processOutputLocationId: number, processOutputLocation: IProcessOutputLocation){
    let url = `${this.processOutputLocationUrl}/${processOutputLocationId}`;
    processOutputLocation.Id = processOutputLocationId;
    return this.httpService.put(url, processOutputLocation);
  }
  
  deleteProcessOutputLocation(processOutputLocationId: number){
    let url = `${this.processOutputLocationUrl}/${processOutputLocationId}`;
    return this.httpService.delete(url);
  }
  //#endregion 

  //#region Process Step Details 

 getProcessRoutingStepInputsByStepId(requestOptions: RequestOptions, processRoutingStepId: number) {
  const processRoutingStepInputUrl = `${this.processRoutingStepInputUrl}/processRoutingStep/${processRoutingStepId}/ProcessRoutingStepInput`;
  return this.httpService.getPaginatedData(processRoutingStepInputUrl, requestOptions);
}
getPartUtilizedQuntityByRoutingId(processRoutingId: number) {
  const url = `${this.processRoutingStepInputUrl}/routing/${processRoutingId}/utilizationByStep`;
  return this.httpService.get(url);
}

getPartBomByRoutingId( processRoutingId: number){
return this.httpService.getData(
    `${this.processRoutingStepUrl}/processRoutingStep/${processRoutingId}/PartBom`
  );
}

deleteProcessRoutingStepInput(processRoutingStepInputId: number){
let url = `${this.processRoutingStepInputUrl}/processRoutingStepInput/${processRoutingStepInputId}`;
return this.httpService.delete(url);

}

addAndUpdateProcessRoutingStepInputByStepId( processRoutingStepInput: ProcessRoutingStepInputProperty[],processRoutingStepId: number| any){
  let url = `${this.processRoutingStepInputUrl}/processRoutingStep/${processRoutingStepId}/SaveInput`;
  return this.httpService.post(url, processRoutingStepInput);
}


getProcessRoutingStepOutputsByStepId(requestOptions: RequestOptions,processRoutingStepId: number) {
  const processRoutingStepOutputUrl = `${this.processRoutingStepOutputUrl}/processRoutingStep/${processRoutingStepId}/ProcessRoutingStepOutput`;
   return this.httpService.getPaginatedData(processRoutingStepOutputUrl, requestOptions);
}

addAndUpdateProcessRoutingStepOutputByStepId( processRoutingStepInput: ProcessRoutingStepInputProperty[],processRoutingStepId: number| any){
  let url = `${this.processRoutingStepOutputUrl}/processRoutingStep/${processRoutingStepId}/SaveOutput`;
  return this.httpService.post(url, processRoutingStepInput);
}
 

deleteProcessRoutingStepOutput(processRoutingStepOutputId: number){
let url = `${this.processRoutingStepOutputUrl}/${processRoutingStepOutputId}`;
return this.httpService.delete(url);
}

getProcessRoutingStepAttributes(requestOptions: RequestOptions, processRoutingStepId: number) {
  const processRoutingStepAttributesUrl = `${this.ProcessRoutingStepAttribute}/processRoutingStep/${processRoutingStepId}/PartAttribute`;
  return this.httpService.getPaginatedData(processRoutingStepAttributesUrl, requestOptions);
}

  //#endregion

  //#region Job schedule

  getWorkStationJobs(workstationId: number){
    return this.httpService.getData("");
  }
  //#endregion
  getDeviceData(deviceName: string){
    let url = `${this.deviceDataUrl}/${deviceName}`; 
    return this.httpService.getData(url);
  }
  
  getDailyData(deviceName: string){
    let url = `${this.dailyDataUrl}/${deviceName}`; 
    return this.httpService.getData(url);
  }

  getDailyAccelerometerData(deviceName: string){
    let url = `${this.dailyAccelerometerDataUrl}/${deviceName}`; 
    return this.httpService.getData(url);
  }

  getSCloudDailyData(deviceName: string){
    let url = `${this.scloudDataUrl}/${deviceName}`; 
    return this.httpService.getData(url);
  }

  getDailyAverageData(deviceName: string){
    let url = `${this.dailyAverageUrl}/${deviceName}`;
    return this.httpService.getData(url);
  }

  getWorkStationsData(){
    return this.httpService.getData(this.workStationsUrl);
  }

  //#region Job
  getJobs(requestOptions: RequestOptions){
    return this.httpService.getPaginatedData(this.jobUrl, requestOptions);
  }

  getJobById(jobId: number){
    return this.httpService.getData(`${this.jobUrl}/${jobId}`);
   }
  //#endregion

  //#region Production items
  getProductionItems(requestOptions: RequestOptions, id: number){
    let productionItemsDetailUrl = `${this.jobUrl}/${id}/ProductionItems`;
    return this.httpService.getPaginatedData(productionItemsDetailUrl, requestOptions);
  }
  //#endregion

  //#region Job inputs
  getJobInputsByJobId(requestOptions: RequestOptions, id: number){
    let jobInputsDetailUrl = `${this.jobUrl}/${id}/JobInputs`;
    return this.httpService.getPaginatedData(jobInputsDetailUrl, requestOptions);
  }
  //#endregion

  //#region Job steps
  getJobStepsByJobId(requestOptions: RequestOptions, id: number){
    let jobStepsDetailUrl = `${this.jobUrl}/${id}/JobSteps`;
    return this.httpService.getPaginatedData(jobStepsDetailUrl, requestOptions);
  }
  //#endregion

  //#region Job events
  getJobEventsByJobId(requestOptions: RequestOptions, id: number){
    let jobEventsDetailUrl = `${this.jobUrl}/${id}/JobEvents`;
    return this.httpService.getPaginatedData(jobEventsDetailUrl, requestOptions);
  }
  //#endregion
  
  getDeviceJobs(workStationId: number){
    var url = `${this.deviceJobsUrl}/${workStationId}/device/test/parts`;
    return this.httpService.getData(url);;
  }

  loadMachineStatuses(){
    return this.httpService.getData(this.machineStatusesUrl);
  }

  loadJobStatuses(){
    return this.httpService.getData(this.jobStatusesUrl);
  }

 //#region maintenance
 getMaintenance(requestOptions: RequestOptions){
  return this.httpService.getPaginatedData(this.maintenanceUrl, requestOptions);
}

addMaintenance(maintenance: IMaintenanceRecurrence){
  return this.httpService.post(this.maintenanceUrl, maintenance);
}

getMaintenanceById(maintenanceId: number){
  return this.httpService.getData(`${this.maintenanceUrl}/${maintenanceId}?$expand=RecurrenceRule,RecurrenceWeekDay`);
 }

updateMaintenance(maintenanceId: number,maintenance: IMaintenance){
  let url = `${this.maintenanceUrl}/${maintenanceId}`;
  maintenance.Id = maintenanceId;
  return this.httpService.put(url, maintenance);
}

deleteMaintenance(maintenanceId: number){
  let url = `${this.maintenanceUrl}/${maintenanceId}`;
  return this.httpService.delete(url);
}

//#endregion

//#region maintenance attachments
getMaintenanceAttachments(requestOptions: RequestOptions, id: number){
  let maintenanceAttachmentsDetailUrl = `${this.maintenanceUrl}/${id}/MaintenanceAttachments`;
  return this.httpService.getPaginatedData(maintenanceAttachmentsDetailUrl, requestOptions);
}

addMaintenanceAttachment(maintenanceId: number, attachment: Attachment){
  let maintenanceAttachmentsDetailUrl = `${this.maintenanceUrl}/${maintenanceId}/MaintenanceAttachments`;
  return this.httpService.post(maintenanceAttachmentsDetailUrl, { MaintenanceId: maintenanceId, ...attachment });
}

getMaintenanceAttachmentById(maintenanceAttachmentId:number){
  return this.httpService.getData(`${this.maintenanceAttachmentUrl}/${maintenanceAttachmentId}`);
}

updateMaintenanceAttachment(maintenanceAttachmentId: number, maintenanceId: number, attachment: Attachment){
  let url = `${this.maintenanceAttachmentUrl}/${maintenanceAttachmentId}`;
  return this.httpService.put(url, { Id: maintenanceAttachmentId, MaintenanceId: maintenanceId, ...attachment });
}

deleteMaintenanceAttachment(maintenanceAttachmentId: number){
  let url = `${this.maintenanceAttachmentUrl}/${maintenanceAttachmentId}`;
  return this.httpService.delete(url);
}
//#endregion

 //#region maintenance type
 getMaintenanceType(requestOptions: RequestOptions){
  return this.httpService.getPaginatedData(this.maintenanceTypeUrl, requestOptions);
}

addMaintenanceType(maintenanceType: IMaintenanceType){
  return this.httpService.post(this.maintenanceTypeUrl, maintenanceType);
}

getMaintenanceTypeById(maintenanceTypeId: number){
  return this.httpService.getData(`${this.maintenanceTypeUrl}/${maintenanceTypeId}`);
 }

updateMaintenanceType(maintenanceTypeId: number,maintenanceType: IMaintenanceType){
  let url = `${this.maintenanceTypeUrl}/${maintenanceTypeId}`;
  maintenanceType.Id = maintenanceTypeId;
  return this.httpService.put(url, maintenanceType);
}

deleteMaintenanceType(maintenanceTypeId: number){
  let url = `${this.maintenanceTypeUrl}/${maintenanceTypeId}`;
  return this.httpService.delete(url);
}

checkIfTypeNameExists(name: string, id: number) : Promise<Boolean>{
  let filter = `Name eq '${name}'`;

  if(id){
    filter+=` and Id ne ${id}`;
  }
  return this.httpService
            .getODataCount(MAINTENANCE_TYPE_ODATA_URL, { filter: filter })
            .then(count => !(count > 0));
}


//#region production dashboard

getAllWorkStationsData(startDate: any, endDate: any  ){
  let params = new HttpParams().append('startDate', ToISODate(startDate).toISOString()).append('endDate', ToISODate(endDate).toISOString());
  return this.httpService.get(this.AllWorkStationsUrl, params);
}

getWorkStationsForDashboard(requestOptions: RequestOptions){
  return this.httpService.getPaginatedData(this.GetWorkStationsForDashboardUrl, requestOptions);
}

getProductionCountByWorkStation(workStationId : any, startRange : any, endRange: any)
{
  let params = new HttpParams().append('startDate', ToISODate(startRange).toISOString()).append('endDate', ToISODate(endRange).toISOString());
  let url = `${this.productionCountByWorkStatinUrl}/${workStationId}`;
  return this.httpService.get(url, params).toPromise();
}

getWorkStationStatusCardData(workStationId : any, startRange?: any, endRange?: any)
{
  if(startRange != null && endRange != null)
  {
    let params = new HttpParams().append('startDate', ToISODate(startRange).toISOString()).append('endDate', ToISODate(endRange).toISOString());
    let url = `${this.workStationStutusDataUrl}/${workStationId}`;
    return this.httpService.get(url, params).toPromise();
  }
  else{
    let url = `${this.workStationStutusDataUrl}/${workStationId}`;
    return this.httpService.getData(url)
  }
}

getCycleTimeByWorkStation(workStationId : any, startRange : any, endRange: any)
{
  let params = new HttpParams().append('startDate', ToISODate(startRange).toISOString()).append('endDate', ToISODate(endRange).toISOString());
  let url = `${this.cycleTimeByWorkStationUrl}/${workStationId}`;
  return this.httpService.get(url, params).toPromise();
}

getOEEAnalysisByWorkStation(workStationId : any)
{
  let url = `${this.oeeAnalysisUrl}/${workStationId}`;
  return this.httpService.getData(url)
}

getHistoryDataByWorkStation(workStationId : any, startRange : any, endRange: any){
  let params = new HttpParams().append('startDate', ToISODate(startRange).toISOString()).append('endDate', ToISODate(endRange).toISOString());
  let url = `${this.historyDataByWorkStationUrl}/${workStationId}`;
  return this.httpService.get(url, params).toPromise();
}

getAvailabilityByWorkStation(workStationId : any, startRange : any, endRange: any)
{
  let params = new HttpParams().append('startDate', ToISODate(startRange).toISOString()).append('endDate', ToISODate(endRange).toISOString());
  let url = `${this.availabilityByWorkStationUrl}/${workStationId}`;
  return this.httpService.get(url, params).toPromise();
}

getPerformanceByWorkStation(workStationId : any, startRange : any, endRange: any)
{
  let params = new HttpParams().append('startDate', ToISODate(startRange).toISOString()).append('endDate', ToISODate(endRange).toISOString());
  let url = `${this.performanceByWorkStationUrl}/${workStationId}`;
  return this.httpService.get(url, params).toPromise();
}

getQualityByWorkStation(workStationId : any, startRange : any, endRange: any)
{
  let params = new HttpParams().append('startDate', ToISODate(startRange).toISOString()).append('endDate', ToISODate(endRange).toISOString());
  let url = `${this.qualityByWorkStationUrl}/${workStationId}`;
  return this.httpService.get(url, params).toPromise();
}

getOEEByWorkStation(workStationId : any, startRange : any, endRange: any)
{
  let params = new HttpParams().append('startDate', ToISODate(startRange).toISOString()).append('endDate', ToISODate(endRange).toISOString());
  let url = `${this.oeeByWorkStationUrl}/${workStationId}`;
  return this.httpService.get(url, params).toPromise();
}

getProductionByDate(workStationId : any, startRange : any, endRange: any)
{
  let params = new HttpParams().append('startDate', ToISODate(startRange).toISOString()).append('endDate', ToISODate(endRange).toISOString());
  let url = `${this.productionByDateUrl}/${workStationId}`;
  return this.httpService.get(url, params).toPromise();
}

getDownTimeAnalysisByWorkStation(workStationId : any, startRange : any, endRange: any)
{
  let params = new HttpParams().append('startDate', ToISODate(startRange).toISOString()).append('endDate', ToISODate(endRange).toISOString());
  let url = `${this.downTimeAnalysisByWorkStationUrl}/${workStationId}`;
  return this.httpService.get(url, params).toPromise();
}
//#endregion

//#region production order

getProductionOrders(requestOptions: RequestOptions){
  return this.httpService.getPaginatedData(this.productionOrderUrl, requestOptions);
}

addProductionOrder(productionOrder: IProductionOrder){
  return this.httpService.post(this.productionOrderUrl, productionOrder);
}

updateProductionOrder(productionOrderId: number, productionOrder: IProductionOrder){
  let url = `${this.productionOrderUrl}/${productionOrderId}`;
  productionOrder.Id = productionOrderId;
  return this.httpService.put(url, productionOrder);
}

getProductionOrderById(productionOrderId:number){
  return this.httpService.getData(`${this.productionOrderUrl}/${productionOrderId}`);
}

deleteProductionOrderById(productionOrderId: number)
{
  let url = `${this.productionOrderUrl}/${productionOrderId}`;
  return this.httpService.delete(url);
}

deleteCompleteProductionOrderByID(productionOrderId: number){
  let url = `${this.productionOrderUrl}/${productionOrderId}/DeleteComplete`;
  return this.httpService.delete(url);
}

getProductionOrderNumber(partId: number){
  let params = new HttpParams()
                      .append("partId", partId);
  let url = `${this.productionOrderUrl}/Generate/Number`;
  return this.httpService.getText(url, params);
}

getPartBomByPartId(partId : number){
  return this.httpService.getData(`${this.partBomUrl}/part/${partId}`);
}

getJobsByProductionOrderId(productionOrderId : number){
  return this.httpService.getData(`${this.scheduleJobUrl}/${productionOrderId}/ProductionOrder/ScheduleJobs`);
}
//#endregion

//#region production order status

checkIfProductionOrderStatusNameExists(name: string, id: number) : Promise<Boolean>{
  let filter = `Name eq '${name}'`;

  if(id){
    filter+=` and Id ne ${id}`;
  }
  return this.httpService
            .getODataCount(PRODUCTION_ORDER_STATUS_ODATA_URL, { filter: filter })
            .then(count => !(count > 0));
}

getProductionOrderStatus(requestOptions: RequestOptions){
  return this.httpService.getPaginatedData(this.productionOrderStatusUrl, requestOptions);
}

deleteProductionOrderStatus(productionOrderStatusId: number)
{
  let url = `${this.productionOrderStatusUrl}/${productionOrderStatusId}`;
  return this.httpService.delete(url);
}

getProductionOrderStatusById(productionOrderStatusId:number){
  return this.httpService.getData(`${this.productionOrderStatusUrl}/${productionOrderStatusId}`);
}

updateProductionOrderStatus(productionOrderStatusId: number, productionOrderStatus: IProductionOrderStatus){
  let url = `${this.productionOrderStatusUrl}/${productionOrderStatusId}`;
  productionOrderStatus.Id = productionOrderStatusId;
  return this.httpService.put(url, productionOrderStatus);
}

addProductionOrderStatus(productionOrderStatus: IProductionOrderStatus){
  return this.httpService.post(this.productionOrderStatusUrl, productionOrderStatus);
}

//#endregion

//#region down time code

checkIfDownTimeCodeNameExists(name: string, id: number) : Promise<Boolean>{
  let filter = `Name eq '${name}'`;

  if(id){
    filter+=` and Id ne ${id}`;
  }
  return this.httpService
            .getODataCount(DOWN_TIME_CODE_ODATA_URL, { filter: filter })
            .then(count => !(count > 0));
}

getDownTimeCode(requestOptions: RequestOptions){
  return this.httpService.getPaginatedData(this.downTimeCodeUrl, requestOptions);
}

deleteDownTimeCode(downTimeCodeId: number)
{
  let url = `${this.downTimeCodeUrl}/${downTimeCodeId}`;
  return this.httpService.delete(url);
}

getDownTimeCodeById(downTimeCodeId:number){
  return this.httpService.getData(`${this.downTimeCodeUrl}/${downTimeCodeId}`);
}

updateDownTimeCode(downTimeCodeId: number, downTimeCode: IDownTimeCode){
  let url = `${this.downTimeCodeUrl}/${downTimeCodeId}`;
  downTimeCode.Id = downTimeCodeId;
  return this.httpService.put(url, downTimeCode);
}

addDownTimeCode(downTimeCode: IDownTimeCode){
  return this.httpService.post(this.downTimeCodeUrl, downTimeCode);
}

//#endregion

//#region production order line

getProductionOrderLinesById(productionOrderId:number){
  return this.httpService.getData(`${this.productionOrderLineUrl}/${productionOrderId}`);
}

getProductionOrderLines(requestOptions: RequestOptions){
  return this.httpService.getPaginatedData(this.productionOrderLineUrl, requestOptions);
}

addProductionOrderLine(productionOrderLine: IProductionOrderLine){
  return this.httpService.post(this.productionOrderLineUrl, productionOrderLine);
}

getProductionOrderLinesByProductionOrderId(requestOptions: RequestOptions, productionOrderId: number){
  let taskCommentsDetailUrl = `${this.productionOrderLineUrl}/${productionOrderId}/ProductionOrderId`;
  return this.httpService.getPaginatedData(taskCommentsDetailUrl, requestOptions);
}

getProductionOrderLinesByProductionOrder(productionOrderId:number){
  return this.httpService.getData(`${this.productionOrderLineUrl}/${productionOrderId}/ProductionOrder`);
}

updateProductionOrderLine(id: number, productionOrderLine: IProductionOrderLine){
  let url = `${this.productionOrderLineUrl}/${id}`;
  productionOrderLine.Id = id;
  return this.httpService.put(url, productionOrderLine);
}

deleteProductionOrderLine(id: number){
  return this.httpService.delete(`${this.productionOrderLineUrl}/${id}`);
}
//#endregion

//#region production line number

getProductionLineNumber(requestOptions: RequestOptions){
  return this.httpService.getPaginatedData(this.productionLineNumberUrl, requestOptions);
}

createProductionLineNumber(productionLineNumber: IProductionLineNumber){
  let url = `${this.productionLineNumberUrl}/ProductionLineNumber`;
  return this.httpService.post(url, productionLineNumber);
}

getProductionLineNumberById(productionLineNumberId: number){
  return this.httpService.getData(`${this.productionLineNumberUrl}/${productionLineNumberId}`);
 }
//#endregion

//#region serial number

getSerialNumber(requestOptions: RequestOptions){
  return this.httpService.getPaginatedData(this.serialNumberUrl, requestOptions);
}

createSerialNumber(productionLineNumber: IProductionLineNumber){
  let url = `${this.serialNumberUrl}/SerialNumber`;
  return this.httpService.post(url, productionLineNumber);
}

getSerialNumberConfigurations(){
  return this.httpService.getOData(this.serialNumberConfigurationOdataUrl, {});
}
//#endregion

addSerialNumberConfiguration(serialNumberConfiguration: ISerialNumberConfiguration){
  return this.httpService.post(this.serialNumberConfigurationUrl, serialNumberConfiguration);
}

getSerialNumberConfiguration(requestOptions: RequestOptions){
  return this.httpService.getPaginatedData(this.serialNumberConfigurationUrl, requestOptions);
}

getSerialNumberConfigurationById(serialNumberConfigurationId: number){
  return this.httpService.getData(`${this.serialNumberConfigurationUrl}/${serialNumberConfigurationId}`)
}

updateSerialNumberConfiguration(serialNumberConfigurationId: number, serialNumberConfiguration: ISerialNumberConfiguration){
  let url = `${this.serialNumberConfigurationUrl}/${serialNumberConfigurationId}`;
  serialNumberConfiguration.Id = serialNumberConfigurationId;
  return this.httpService.put(url, serialNumberConfiguration);
}

deleteSerialNumberConfiguration(serialNumberConfigurationId: number){
  let url = `${this.serialNumberConfigurationUrl}/${serialNumberConfigurationId}`;
  return this.httpService.delete(url);
}

addPartCategorySerialNumberConfiguration(serialNumberConfiguration: IPartCategorySerialConfiguration){
  return this.httpService.post(this.partCategprySerialNumberConfigurationUrl, serialNumberConfiguration);
}

deletePartCategorySerialNumberConfiguration(partCategorySerialNumberConfigurationId: number){
  let url = `${this.partCategprySerialNumberConfigurationUrl}/${partCategorySerialNumberConfigurationId}`;
  return this.httpService.delete(url);
}

getPartCategorySerialNumberConfigurationById(partCategorySerialNumberConfigurationId: number) {
  return this.httpService.getData(`${this.partCategprySerialNumberConfigurationUrl}/${partCategorySerialNumberConfigurationId}`);
}

updatePartCategorySerialNumberConfiguration(serialNumberConfigurationId: number, partCategorySerialNumberConfiguration: IPartCategorySerialConfiguration){
  let url = `${this.partCategprySerialNumberConfigurationUrl}/${serialNumberConfigurationId}`;
  partCategorySerialNumberConfiguration.Id = serialNumberConfigurationId;
  return this.httpService.put(url, partCategorySerialNumberConfiguration);
}

addPartSerialNumberConfiguration(serialNumberConfiguration: IPartSerialConfiguration){
  return this.httpService.post(this.partSerialNumberConfigurationUrl, serialNumberConfiguration);
}

deletePartSerialNumberConfiguration(partSerialNumberConfigurationId: number){
  let url = `${this.partSerialNumberConfigurationUrl}/${partSerialNumberConfigurationId}`;
  return this.httpService.delete(url);
}

updatePartSerialNumberConfiguration(serialNumberConfigurationId: number, partSerialNumberConfiguration: IPartSerialConfiguration){
  let url = `${this.partSerialNumberConfigurationUrl}/${serialNumberConfigurationId}`;
  partSerialNumberConfiguration.Id = serialNumberConfigurationId;
  return this.httpService.put(url, partSerialNumberConfiguration);
}

getPartSerialNumberConfigurationById(partSerialNumberConfigurationId: number) {
  return this.httpService.getData(`${this.partSerialNumberConfigurationUrl}/${partSerialNumberConfigurationId}`);
}

addSerialNumberDetail(serialNumberdetail: ISerialNumberDetail){
  return this.httpService.post(this.serialNumberDetailUrl, serialNumberdetail);
}

getSerialNumberDetail(serialNumberId: number, serialNumberConfigureId:number){
  return this.httpService.getData(`${this.serialNumberDetailUrl}/${serialNumberId}/${serialNumberConfigureId}`);
}

updateSerialNumberDetail(serialNumberDetailId: number, serialNumberDetail: ISerialNumberDetail){
  let url = `${this.serialNumberDetailUrl}/${serialNumberDetailId}`;
  serialNumberDetail.Id = serialNumberDetailId;
  return this.httpService.put(url, serialNumberDetail);
}

assignSerialNumber(assihnSerialNumberData: IAssignSerialNumberFormData){
  let url =`${this.productionLineNumberUrl}/AssignSerialNumber`;
  return this.httpService.post(url, assihnSerialNumberData);
}

getOrdersByCustomeId(customerId: number){
  return this.httpService.getData(`${this.productionUrl}/${customerId}`);
 }
//#endregion

//#region batch number

getBatchNumber(requestOptions: RequestOptions){
  return this.httpService.getPaginatedData(this.batchNumberUrl, requestOptions);
}

createBatchNumber(batchNumber: IProductionLineNumber){
  let url = `${this.batchNumberUrl}/BatchNumber`;
  return this.httpService.post(url, batchNumber);
}

//#endregion

//#region Down time code

getEnabledDownTimeCodes(){
  return this.httpService.getData(`${this.downTimeCodeUrl}/EnabledDowmTimeCode`);
}

addDownTimeData(downTimeData: IDownTimeData){
  let url =`${this.downTimeDataUrl}`;
  return this.httpService.post(url, downTimeData);
}

//#endregion


//#region machine utility dashboard
getMachineUtilityDashboard(machineUtilityDashboard: IMachineUtilityDashboard){
  let url = `${this.machineUtilityDashboard}`
  return  this.httpService.post(url,machineUtilityDashboard);
}

getMachineUtilityDashboardGrid(machineUtilityDashboard: IMachineUtilityDashboard){
  let url = `${this.machineUtilityDashboardGrid}`
  return this.httpService.post(url,machineUtilityDashboard)
}

//#endregion

//#region  QC view 
  getQCPagedData(requestOptions: RequestOptions){
    let url = `${this.jobUrl}/QCDetailsView`;
    return this.httpService.getPaginatedData(url, requestOptions);
  }

  getQCDetailsByJobExecutionId(jobExecutionId: number){
    let url = `${this.jobExecutionQualityUrl}/${jobExecutionId}/checksheet`;
    return this.httpService.getData(url);
  }

  postQCDetails(qcDetails: ChecksheetStepRowDto[]){
    let url = `${this.jobExecutionQualityUrl}/QualityData`;
    return this.httpService.post(url, qcDetails);
  }

  getLockedProductionLines(jobId: number){
    let url = `${this.jobExecutionQualityUrl}/${jobId}/LockedProductionLines`;
    return this.httpService.getData(url);
  }
//#endregion

//#region Rework Job

  createReworkJob(request: { jobId: number, productionLineNumberIds: number[] }){
    let url = `${this.reworkJobUrl}/${request.jobId}/CreateReworkJob`;
    return this.httpService.post(url, { ProductionLineNumberIds: request.productionLineNumberIds });
  }

  createReworkJobForPLN(ICreateReworkPLN: ICreateReworkPLN){
    let url = `${this.reworkJobUrl}/Create`;
    return this.httpService.post(url, ICreateReworkPLN);
  }

//#endregion

//#region Reject Job

  createRejectJob(request: { jobId: number, productionLineNumberIds: number[] }){
    let url = `${this.rejectJobUrl}/${request.jobId}/CreateRejectJob`;
    return this.httpService.post(url, { ProductionLineNumberIds: request.productionLineNumberIds });
  }

  createRejectJobForPLN(ICreateRejectPLN: ICreateRejectPLN){
    let url = `${this.rejectJobUrl}/Create`;
    return this.httpService.post(url, ICreateRejectPLN);
  }
//#endregion
}
